import { get, put } from "@/api/implementation/app";

export const show = (clientId) => get(`client/${clientId}/country`);

export const update = (client) => put(`client/${client.id}/country`, client);
